<template>
  <Report
    :report-id="reportId"
    title="Conversations"
    tooltip-text="A trend showing the number of recently created conversations"
    class="chart-container"
    :dataEmpty="isDataEmpty"
    :loadedData="isDataLoaded"
    :loadingError="loadingError"
  >
    <template #header-addons>
      <span class="button" :class="{ 'is-static': showLineChart }" @click="switchLineChart()">
        <font-awesome-icon icon="chart-line"></font-awesome-icon>
      </span>
      <span class="button" :class="{ 'is-static': showBarChart }" @click="switchBarChart()">
        <font-awesome-icon icon="chart-bar"></font-awesome-icon>
      </span>
    </template>

    <template #chart>
      <LineChart
        :reportId="reportId"
        class="chart"
        v-if="showLineChart"
        :data="data"
        :fill="false"
        :allowDecimalTicksY="false"
        :seriesOrder="['Conversations']"
      />
      <BarChart :reportId="reportId" class="chart" v-if="showBarChart" :data="data" :seriesOrder="['Conversations']" />
    </template>
  </Report>
</template>

<script lang="ts" setup>
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import { Data } from '../../models';
import { ChartType } from '../../models/chartType';
import { computed, PropType, ref } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';

const props = defineProps({
  data: {
    type: [Object, undefined] as PropType<Data | undefined>,
    required: false,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
});

const { reportId, isDataLoaded, isDataEmpty } = useReportData(props);

const chartType = ref(ChartType.BAR);

const showLineChart = computed(() => chartType.value === ChartType.LINE);
const showBarChart = computed(() => chartType.value === ChartType.BAR);

const switchBarChart = () => (chartType.value = ChartType.BAR);
const switchLineChart = () => (chartType.value = ChartType.LINE);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;
</style>
